import { catchError, get, post, put } from '@/modules/shared/http_handler'
import type { RequestError } from '@/modules/shared/domain/requestError'
import type {
  BusinessProfile,
  BusinessProfileResponse,
  ChangePasswordRequest,
  ChangePasswordResponse,
  UpdateBusinessProfileResponse,
} from '../domain/entity/businessProfile'

export const getBusinessProfile = async (): Promise<
  [RequestError | undefined, BusinessProfileResponse | undefined]
> => {
  return catchError(get<BusinessProfileResponse>('/settings/business-profile'))
}

export const updateBusinessProfile = async (
  profile: BusinessProfile,
): Promise<[RequestError | undefined, UpdateBusinessProfileResponse | undefined]> => {
  // modifiedAtUtc is server-owned; the endpoint ignores it either way, but
  // sending it back invites someone to treat it as an optimistic-lock token
  // it is not.
  const payload: Record<string, unknown> = { ...profile }
  delete payload.modifiedAtUtc
  return catchError(put<UpdateBusinessProfileResponse>('/settings/business-profile', payload))
}

export const changePassword = async (
  request: ChangePasswordRequest,
): Promise<[RequestError | undefined, ChangePasswordResponse | undefined]> => {
  return catchError(
    post<ChangePasswordResponse>('/web/auth/change-password', {
      currentPassword: request.currentPassword,
      newPassword: request.newPassword,
    }),
  )
}
